import { PromoBanner } from '../PromoBanner';

type TMostOfRioMidnightUpsellProps = {
  className?: string;
};

export function MostOfRioMidnightUpsell(props: TMostOfRioMidnightUpsellProps) {
  return (
    <PromoBanner
      className={props.className}
      url="https://rio.gg/mostofriomns1_up"
      blurb={'\u{1F31F} Midnight is upon us! Make the most of your Warcraft experience as you venture into the new expansion, with Raider.IO\u2019s innovative and exciting features. Check out our refresher to learn more! \u{1F680}'}
      buttonText="Learn More"
      trackingSlug="most_of_rio_mdn_s1_upsell"
      imagePath="/images/upsells/most-of-rio-mdn-s1/banner.webp"
      imageAlt="Make the Most of Raider.IO for Midnight Season 1"
      borderColor="#d4a843"
      background="linear-gradient(76deg, #0d2a2d 0%, #1a3a3e 50%, #0d2a2d 100%)"
      buttonColor="#d4a843"
    />
  );
}
